<script setup>
import { watch } from 'vue';
import { useStore } from 'vuex';
import TicketViewPage from '../pages/TicketViewPage.vue';

const props = defineProps({
  ticketId: {
    type: [Number, String],
    required: true,
  },
  columnId: {
    type: [Number, String],
    default: null,
  },
  hasNext: {
    type: Boolean,
    default: false,
  },
  hasPrevious: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'navigate-next', 'navigate-previous']);

const show = defineModel('show', { type: Boolean, default: false });
const store = useStore();

const handleClose = () => {
  show.value = false;
  emit('close');
};

const handleNavigateNext = () => {
  emit('navigate-next');
};

const handleNavigatePrevious = () => {
  emit('navigate-previous');
};

// Watch for ticket updates - the kanban will automatically reflect changes
// through the store's UPDATE_TICKET mutation which updates the tickets list
watch(
  () => store.getters['tickets/getCurrentTicket'],
  () => {
    // Ticket was updated, changes will be reflected in kanban automatically
    // since UPDATE_TICKET mutation updates the tickets array
  },
  { deep: true }
);
</script>

<template>
  <woot-modal
    v-model:show="show"
    :on-close="handleClose"
    modal-type="centered"
    size="medium"
  >
    <div class="modal-ticket-view">
      <TicketViewPage
        :ticket-id="ticketId"
        :is-modal="true"
        :column-id="columnId"
        :has-next="hasNext"
        :has-previous="hasPrevious"
        @close="handleClose"
        @navigate-next="handleNavigateNext"
        @navigate-previous="handleNavigatePrevious"
      />
    </div>
  </woot-modal>
</template>

<style lang="postcss" scoped>
.modal-ticket-view {
  @apply w-full h-full;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
